import {IReduxNotificationsState} from '../../@interfaces';

const state: IReduxNotificationsState = {
    unreadNumber: 0,
    listDisplayed: false,
};

export default state;
